import styled, { css } from 'styled-components';
import type { TextareaAutosizeProps } from 'react-textarea-autosize';
import TextareaAutosize from 'react-textarea-autosize';

export type Props = {
  $hasError?: boolean,
  $isBorderlessStyle?: boolean,
} & TextareaAutosizeProps;

const TextArea = styled(TextareaAutosize)<Props>`
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  overflow: auto;
  font-size: var(--font-size-default);
  line-height: var(--line-height-text);
  resize: none;
  color: var(--color-text-default);
  ${({ $isBorderlessStyle }) => !$isBorderlessStyle && css`
    padding: 4px 6px;
    border: var(--border-input);
    border-radius: var(--border-radius-input);
    background-color: var(--color-input-background);

    &:focus {
      outline: var(--outline-input-focus);
    }
  `}
  ${({ $isBorderlessStyle }) => $isBorderlessStyle && css`
    outline: none;
    border: none;
    padding: 0;
    background-color: inherit;
  `}

  &::placeholder {
    color: var(--color-input-placeholder);
    opacity: 1;
  }

  &[disabled] {
    background-color: var(--color-background-disabled);
    border-color: var(--color-input-border-disabled);
  }

  ${({ $hasError }) => $hasError && css`
    &:not(:focus) {
      color: var(--color-error);
      border-color: var(--color-error);
    }
  `}
`;

export default TextArea;
